import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard  {
  canDeactivate(
    component: CanComponentDeactivate
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate();
  }
}

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Promise<boolean>;
}